module.exports = __webpack_public_path__ + "static/img/xwj2.99d35c73.png";